var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addcurrencyMapping.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: !_vm.selsString },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(_vm.selsString)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchDelete")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClick }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              type: "selection",
              label: _vm.$t("idLabel"),
              width: "50"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "currency_name", label: _vm.$t("currencyName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "currency", label: _vm.$t("currencySymbol") }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "120", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addcurrencyMapping.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete([row.id])
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addcurrencyMapping", {
        ref: "addcurrencyMapping",
        on: { update: _vm.searchClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }